import React, { useContext, useState } from "react";
import { FaQrcode } from "react-icons/fa";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import api from "../../api";
import Button from "../../components/Button";
import Header from "../../components/Header";
import InputField from "../../components/InputField";
import { LoaderContext } from "../../context/LoaderContext";
import {
  StyledAuthLogoContainer,
  StyledMainContainer,
} from "../../styles/global";
import { StyledResetPasswordCard } from "./styled";

interface Props {}

const ResetPassword: React.FC<Props> = () => {
  const { token } = useParams();
  const { showLoader } = useContext(LoaderContext);
  const navigate = useNavigate();
  const [state, setState] = useState({
    newPassword: "",
    confirmPassword: "",
  });

  const [errors, setErrors] = useState({
    newPasswordError: "",
    confirmPasswordError: "",
  });

  const handleOnFocus = (e: React.FocusEvent<HTMLInputElement>) => {
    setErrors({
      ...errors,
      [e.target.name + "Error"]: "",
    });
  };

  const hasError = () => {
    let hasError = errors;
    hasError.newPasswordError = !state.newPassword
      ? "Password is required"
      : "";
    hasError.confirmPasswordError = !state.confirmPassword
      ? "Confirm Password is required"
      : state.confirmPassword !== state.newPassword
      ? "Password and Confirm Password must be same"
      : "";
    setErrors({ ...hasError });
    return !!(hasError.newPasswordError || hasError.confirmPasswordError);
  };

  const handlePasswordReset = async (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    e.preventDefault();
    let error = hasError();
    if (error) {
      toast.error("Some error occurred");
      return;
    }

    showLoader({
      show: true,
    });
    await api
      .ResetPassword({
        newPassword: state.newPassword,
        token: token || "",
      })
      .then((res) => {
        if (res.status === 200) {
          showLoader({
            show: false,
          });
          toast.success(res.data.message);
          navigate("/login");
        }
      })
      .catch((err) => {
        toast.error(
          err.response?.data?.message ||
            "Something went wrong! please try again later."
        );
      })
      .finally(() => {
        showLoader({
          show: false,
        });
        setState({
          newPassword: "",
          confirmPassword: "",
        });
      });
  };
  return (
    <>
      <Header title="WhatQR" />

      <StyledMainContainer onClick={() => {}}>
        <StyledAuthLogoContainer>
          <FaQrcode />
        </StyledAuthLogoContainer>
        <StyledResetPasswordCard>
          <InputField
            name="newPassword"
            placeholder="Enter a new password"
            label="New password"
            type="password"
            value={state.newPassword}
            error={errors.newPasswordError}
            onFocus={handleOnFocus}
            onChange={(e) => {
              setState({
                ...state,
                newPassword: e.target.value,
              });
            }}
          />
          <InputField
            name="confirmPassword"
            placeholder="Confirm the new password"
            label="Confirm password"
            type="text"
            value={state.confirmPassword}
            error={errors.confirmPasswordError}
            onFocus={handleOnFocus}
            onChange={(e) => {
              setState({
                ...state,
                confirmPassword: e.target.value,
              });
            }}
          />

          <Button
            onClick={(e) => {
              handlePasswordReset(e);
            }}
            label="Reset Password"
          />
        </StyledResetPasswordCard>
      </StyledMainContainer>
    </>
  );
};

export default ResetPassword;
